import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import ResourceMarkdown from '../../../components/V2/BlockItem/Resource/ResourceMarkdown';
import { useResoure } from '../../../hooks/V2/useResource';
import { ChevronRightIcon } from '@chakra-ui/icons';

const ResourcePage = () => {
	const navigate = useNavigate();
	// get resource ID from params
	const resourceId = useParams<{ resourceId: string }>().resourceId;
	const { data: resource, refetch: refetchResource } = useResoure(resourceId);

	useEffect(() => {
		if (resourceId) {
			refetchResource();
		}
	}, [resourceId, refetchResource]);

	return (
		<Box p={{ base: '16px', md: '32px' }} pb="100px !important">
			<Breadcrumb mb="20px" separator={<ChevronRightIcon boxSize="16px" color="#544D4F" />}>
				<BreadcrumbItem>
					<BreadcrumbLink
						onClick={() => {
							navigate(-1);
						}}
					>
						Cheatsheet
					</BreadcrumbLink>
				</BreadcrumbItem>

				<BreadcrumbItem isCurrentPage color="#4358F6">
					<BreadcrumbLink href="#">View Details</BreadcrumbLink>
				</BreadcrumbItem>
			</Breadcrumb>

			<ResourceMarkdown resource={resource} />
		</Box>
	);
};

export default ResourcePage;
